import React from 'react';
import { RegisterButton } from './styles';

interface Props {
  text: string;
  onClick: VoidFunction;
  isDisabled: boolean;
  isLoading: boolean;
}

export const RegisterUserButton = ({ isDisabled, onClick, text, isLoading }: Props) => {
  return (
    <RegisterButton
      data-testid="register-button"
      disabled={isDisabled}
      onClick={onClick}
      text={text}
      loading={isLoading}
    />
  );
};
